<template>
<el-container class="container backBoxbb" ref="container1" 
    style="display: flex;flex-direction:column;" >

<el-main ref="elmaincards1" style="justify-content: flex-start;display: flex;flex-direction:column;">
  <div class="flex_row" style="max-width:700px;width:100%;flex-wrap:wrap;">
    <div class="flex_row" style="width:100%;max-width:350px;">
    <el-date-picker
      v-model="valueDate[0]" style="max-width:250px;margin:0px 0px 10px 0;"
      type="date" value-format="yyyy-MM-dd"
      placeholder="开始日期" :size="size">
    </el-date-picker><span style="line-height: 32px;margin:0px 5px 10px">—</span>
    <el-date-picker
      v-model="valueDate[1]" style="max-width:250px;margin:0px 10px 10px 0;"
      type="date" value-format="yyyy-MM-dd"
      placeholder="结束日期" :size="size">
    </el-date-picker>
    </div>
    <div class="flex_row" style="width:100%;max-width:350px;">
      <el-select v-model="station" clearable :size="size" 
          placeholder="站点" style="margin:0 10px 10px 0;flex-grow:1">
        <el-option
          v-for="item in stationList"
          :key="item.station"
          :label="item.station"
          :value="item.station">
        </el-option>
      </el-select>
      <el-input :size="size" v-model="usecode" 
        :maxlength="11" clearable style="margin:0px 10px 10px 0;">
        <span slot="prepend">气瓶</span>
      </el-input>
    </div>
  </div>
  <div class="flex_row" style="max-width:700px;width:100%;flex-wrap:wrap;">
    <el-button type="success"  :size="size"  class="button" :plain="activebt!=1" style="margin:0 10px 10px 0;"
      @click="getSaleList(1)">{{btCaption[0]}}</el-button>
    <el-button type="success"  :size="size"  class="button" :plain="activebt!=2" style="margin:0 10px 10px 0;"
      @click="getSaleList(2)">{{btCaption[1]}}</el-button>
    <el-button type="success"  :size="size"  class="button" :plain="activebt!=4" style="margin:0 10px 10px 0;"
      @click="getSaleList(3)">{{btCaption[2]}}</el-button><div style="flex-grow:1;"></div>
    <el-button type="primary"  :size="size"  class="button" style="margin:0 10px 10px 0;" 
      @click="showGasInfo=true">导入</el-button>
  </div>
  <el-table v-if="activebt<=10"  height="700" :size="size" ref="multipleTable" :data="QueryData1" highlight-current-row 
    v-loading="listLoading" element-loading-text="Loading..." :fit="true" :key="refrsh"
				element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.65)"
				border tooltip-effect="dark" :header-cell-style="tableHeaderColor"  >
      <div slot="empty" >暂无数据</div>
      <el-table-column prop="px" label="序" width="40" align1="center" show-overflow-tooltip>
      </el-table-column>
      
      <el-table-column prop="tagid" label="电子标签" width="80" min-width="60"  show-overflow-tooltip></el-table-column>
      <el-table-column prop="yhno" label="气瓶编号" width="90" min-width="60"  show-overflow-tooltip></el-table-column>
      <el-table-column prop="keygpno" label="气瓶钢印" width="120" min-width="60"  show-overflow-tooltip></el-table-column>
      <el-table-column prop="name" label="气瓶名称" width="100" min-width="60"  show-overflow-tooltip></el-table-column>
      <el-table-column prop="kg" label="规格" width="60" min-width="60"  show-overflow-tooltip></el-table-column>
      <el-table-column prop="LogTime" label="操作时间" width="160" min-width="60"  show-overflow-tooltip></el-table-column>
      <el-table-column prop="zzrq" label="制造日期" width="90" min-width="60"  show-overflow-tooltip></el-table-column>
      <el-table-column prop="madename" label="制造商" width="120" min-width="60"  show-overflow-tooltip></el-table-column>
      <el-table-column prop="xcjy" label="下次检验" width="90" min-width="60"  show-overflow-tooltip></el-table-column>
      <el-table-column prop="zjsm" label="最近扫码"  min-width="70"  show-overflow-tooltip></el-table-column>
    </el-table>
</el-main>
<el-pagination style="margin-bottom:5px;" 
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :current-page.sync="pageno"
        :page-sizes="[20, 50, 100]"
        :page-size="pagesize"
        :layout="pagelayout"
        :total="totalcount">
      </el-pagination>
    <el-drawer
      :visible.sync="showGasInfo"
      direction="rtl" append-to-body :wrapperClosable="false"
      custom-class="drawer-prmit"
      ref="drawerPrmit"
      >
      <div class="demo-drawer__content">
      <div style="height:40px;margin-left:20px;color:#666;">气瓶检修导入</div>
      
      <div>
        <div style="margin:20px 0px;padding:10px 25px;background-color:#FFFFFF;">
          <div style="font-size: 13px;color:#999;">
            支持几种格式，请注意字段变化。</div>
        </div>
        <div style="padding:15px 20px 1px 10px;background-color:#FFFFFF;">
          <el-form >
            <el-form-item label="" label-width="10px" >
              <el-input  type="textarea"
                  :rows="15" :show-word-limit="true"
                  placeholder="把Excel内容粘贴到这里" v-model="GasList" clearable></el-input>
            </el-form-item>
            
          </el-form>
        </div>
      </div>
      <div class="demo-drawer__footer" style="margin:20px">
          <el-button type="primary" @click="addGasInfo" :size="size" :loading="downfileloading" style="float: right;margin-right:5px;">确 定</el-button>
          <el-button @click="showGasInfo=false" :size="size" style="float: right;margin-right:25px;">取 消</el-button>
      </div>
      
    </div>
    </el-drawer>
</el-container>  
</template>

<script>
/* eslint-disable */
export default {
  data() {
    return {
      size: 'medium',//medium,small,mini,
      tableHeight:500,
      listLoading:false,
      downfileloading:false,
      valueDate:['2022-02-01','2022-03-06'],
      station:"",
      stationList:[],
      QueryData1:[],
      usecode:"",
      activebt:0,
      pageno:1,
      pagesize:20,
      totalcount:0,//记录总数
      pagelayout:"total,sizes,prev,pager,next,jumper",
      btCaption:['最近编辑','最近扫码','扫码流水'],
      refrsh:true,
      showGasInfo:false,
      GasList:"",
    }
  },
  watch:{

  },
  computed: {
    
  },
  mounted(){
    this.valueDate=[this.$api.formatDate(new Date()),this.$api.formatDate(new Date())]
    this.getStationList();
    this.initDivSize();
  },
  methods: {
    addGasInfo(){
      this.downfileloading=true;
      let data = {
        lx: "addgasinfo",
        sqlone:this.GasList,
        procext:"report"
      };
      this.$api.post("",data,(res) => {
          if (res["status"] == "1") {
              this.$message.success(res.message);
              this.downfileloading=false;
              return
          }else{
            this.$message.error(res.message);
          }
          if (res["status"] == "-2") {
            this.$parent.$parent.$parent.swapToken();
          }
          this.downfileloading=false;
        },
        (failure) => {}
      );
    },
    handleSizeChange(val) {
      this.pagesize=val
      let pagesizes=JSON.parse(localStorage.getItem("pagesizes") || "{}");
      pagesizes["emptygas"]=val
      localStorage.setItem("pagesizes",JSON.stringify(pagesizes))
      if (this.totalcount==0) return
      this.getSaleList(0)
    },
    handlePageChange(val) {
      if (this.totalcount==0) return
      this.pageno=val
      this.getSaleList(0)
    },
    dateRange(e){
      console.log(e,this.valueDate)
    },
    getSaleList(bt){
      this.listLoading=true
      let para={};
      if (this.valueDate!=null){
        para.ksrq=this.valueDate[0]
        para.jsrq=this.valueDate[1]
      }
      para.usecode=this.usecode;
      para.station=this.station;
      if (bt>0)this.activebt=bt;
      let data = {
        lx: "getgasinfolist",
        sqlone:(bt>0?bt:this.activebt),
        sqltwo:JSON.stringify(para),
        pageno:(bt>0?-1:this.pageno),
        pagesize:this.pagesize,
        procext:"report"
      };
      this.$api.post("",data,
        (res) => {
          if (res["status"] == "1") {
            this.totalcount=parseInt(res.totalcount)
            this.pageno=parseInt(res.pageno)
            this.pagesize=parseInt(res.pagesize)
            //console.log(res.records)
            this.QueryData1=res.records
            
            this.refrsh=!this.refrsh;
          }else
            this.$message.error(res["message"]);
          if (res["status"] == "-2") {
            this.$parent.$parent.$parent.swapToken();
          }
          this.listLoading=false
        },
        (failure) => {}
      );
    },
    EnterFun(e){

    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return 'background-color: #f0f0f0;'
        }
    },
    getStationList(){
      let data = {
        lx: "getstationlist",
        procext:"report"
      };
      this.$api.post("",data,
        (res) => {
          if (res["status"] == "1") {
            this.stationList=res.records
            return
          }else
            this.$message.error(res["message"]);
          if (res["status"] == "-2") {
            this.$parent.$parent.$parent.swapToken();
          }
        },
        (failure) => {}
      );
    },
    initDivSize() {
      this.isPc=this.$store.getters.GettabBarInfo("isPc");
      if (this.isPc){
        //this.pagelayout="total,sizes,prev,pager,next,jumper"
      }else{
        this.pagelayout="total,prev,pager,next"
        this.btCaption=['编辑','扫码','流水']
      }
      
    },
  },
  created() {
   let pagesizes=JSON.parse(localStorage.getItem("pagesizes") || "{}");
    if (pagesizes && pagesizes["emptygas"])
      this.pagesize=parseInt(pagesizes["emptygas"])
    //this.getSaleList(2)
  },
};
</script>
<!--公共样式(或者是width: 0;)-->

<style src = "../../Styles/cover.css"></style>
<style src = "../../Styles/common.css"></style>
<style src = "../../Styles/iconfont/iconfont.css"></style>

<style>
.backBoxbb .el-main {
  padding: 10px 20px 5px 10px !important;
}
.backBoxbb .flex_row .el-input-group__prepend{
  padding: 0 10px !important;
}
</style>

<style scoped>
.myscrollbar::-webkit-scrollbar{
display:none;
}
.container {
  width: 100%;
  height: 100%;

}
.flex_row{
    display: flex;             /*设置为flex布局*/
    justify-content: flex-start;   /*水平居中*/
    align-items: center;       /*垂直居中*/
    flex-direction: row;
}
.flex_col{
    display: flex;             /*设置为flex布局*/
    justify-content: flex-start;   /*水平居中*/
    align-items: flex-start;       /*垂直居中*/
    flex-direction: column;
}


</style>